import React, { useEffect } from 'react'
import { useState } from 'react'
import CircleIcon from '../Common/CircleIcon'
import Svgs from '../Common/Svgs'
import Button from '../Common/Button'

const Three = (props) => {
    const [Text, setText] = useState([]);
    const [error, setError] = useState('')
    debugger;
    if (props.Active == 6) {
        if (props.Language.lang == 'EN') {
            if (props.State.experience == 'Happy')
                props.Language.text = props.Language.text.replace('%%', 'did');
            else
                props.Language.text = props.Language.text.replace('%%', "didn't");
        }
        else if (props.Language.lang == 'UR') {
            if (props.State.experience == 'Happy')
                props.Language.text = props.Language.text.replace('%%', '')
            else
                props.Language.text = props.Language.text.replace('%%', "نہیں")
        }
    }
    const handleChange = (param) => {
        const clonedLikes = [...(props.State?.like || [])];
        const likes = clonedLikes?.includes(param) ? clonedLikes.filter(clonedLike => clonedLike !== param) : [...clonedLikes, param];
        props.setState({ ...props.State, like: likes });

        const errorMsg = likes.length > 0 ? '' : 'Select atleast one field';
        setError(errorMsg);
    }

    useEffect(() => {
        debugger;
        setText(props.Language)
    }, [props.Language])

    const goNext = (e) => {
        if (props.State.like && props.State.like.length > 0) {
            return props.setActive(props.Active + 1)
        }

        setError('Select atleast one field');
    }

    return (
        <div className='slide-in-right  flex flex-col gap-6 items-center'>
            <h1 className={`text-3xl font-extrabold ${Text?.lang == 'UR' && 'urdu'}`}>{Text?.text}</h1>
            <div className={`flex items-center justify-center gap-5 flex-wrap ${Text?.lang == 'UR' && 'urdu'}`}>
                <CircleIcon
                    onClick={() => {
                        handleChange('Overall Experience')
                    }}
                    icon={
                        <img src={`${process.env.PUBLIC_URL}/assets/images/quality.png`} className='w-[5rem]' />
                    }
                    text={Text?.options ? Text.options[0] : ''}
                    selected={props.State?.like?.includes('Overall Experience')}
                />

                <CircleIcon
                    onClick={() => {
                        handleChange('Service')
                    }}
                    icon={
                        <Svgs.Service />
                    }
                    text={Text?.options ? Text.options[1] : ''}
                    selected={props.State?.like?.includes('Service')}
                />

                <CircleIcon
                    onClick={() => {
                        handleChange('Food')
                    }}
                    icon={
                        <img src={`${process.env.PUBLIC_URL}/assets/images/food.png`} className='w-[5rem]' />
                    }
                    text={Text?.options ? Text.options[2] : ''}
                    selected={props.State?.like?.includes('Food')}
                />

                <CircleIcon
                    onClick={() => {
                        handleChange('Cleanliness')
                    }}
                    icon={
                        <Svgs.Cleanliness />
                    }
                    text={Text?.options ? Text.options[3] : ''}
                    selected={props.State?.like?.includes('Cleanliness')}
                />
            </div>

            {/* {error && <div>{error}</div>} */}
            <Button text={'Next'} onClick={goNext} />
        </div>
    )
}

export default Three
//import React, { useEffect } from 'react'
//import { useState } from 'react'
//import CircleIcon from '../Common/CircleIcon'
//import Svgs from '../Common/Svgs'

//const Three = (props) => {
//    const handleChange = (param) => {
//        props.setState({ ...props.State, like: param });
//        props.setActive(props.Active + 1)
//    }

//    const [Text, setText] = useState([]);
//    useEffect(() => {
//        setText(props.Language)
//    }, [props.Language])

//    return (
//        <div className='slide-in-right  flex flex-col gap-6 items-center'>
//            <h1 className={`text-3xl font-extrabold ${Text?.lang == 'UR' && 'urdu'}`}>{Text?.text}</h1>
//            <div className={`flex items-center justify-center gap-5 flex-wrap ${Text?.lang == 'UR' && 'urdu'}`}>
//                <CircleIcon
//                    onClick={() => {
//                        handleChange('Overall Experience')
//                    }}
//                    icon={
//                        <img src={`${process.env.PUBLIC_URL}/assets/images/quality.png`} className='w-[5rem]' />
//                    }
//                    text={Text?.options ? Text.options[0] : ''}
//                />

//                <CircleIcon
//                    onClick={() => {
//                        handleChange('Service')
//                    }}
//                    icon={
//                        <Svgs.Service />
//                    }
//                    text={Text?.options ? Text.options[1] : ''}
//                />

//                <CircleIcon
//                    onClick={() => {
//                        handleChange('Food')
//                    }}
//                    icon={
//                        <img src={`${process.env.PUBLIC_URL}/assets/images/food.png`} className='w-[5rem]' />
//                    }
//                    text={Text?.options ? Text.options[2] : ''}
//                />

//                <CircleIcon
//                    onClick={() => {
//                        handleChange('Cleanliness')
//                    }}
//                    icon={
//                        <Svgs.Cleanliness />
//                    }
//                    text={Text?.options ? Text.options[3] : ''}
//                />
//            </div>
//        </div>
//    )
//}

//export default Three